import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
import { Field } from "formik";
import { MinimalPlayer } from "../../video";
import { styled } from "../../theme";
import { Caption } from "./Caption";
import { LanguageControls } from "./LanguageControls";
export const BlockMandatoryVideo = ({ children, reference, }) => {
    const [activeMutationIndex, setActiveMutationIndex] = useState(0);
    const currentMutation = children[activeMutationIndex];
    const Container = styled.div `
    box-sizing: content-box;
  `;
    const VideoFrame = styled.div `
    text-align: center;
    display: flex;
    justify-content: center;
  `;
    return (_jsxs(Container, { children: [_jsx(LanguageControls, { activeMutationIndex: activeMutationIndex, mutations: children, onChange: index => setActiveMutationIndex(index) }), _jsx(VideoFrame, { children: _jsx(Field, { name: reference.id, children: (formik) => (_jsx(MinimalPlayer, { controls: false, playsInline: true, source: currentMutation.video.source, poster: currentMutation.video.poster, width: currentMutation.video.width, height: currentMutation.video.height, onEnd: () => {
                            formik.form.setFieldTouched(formik.field.name, true);
                            formik.form.setFieldValue(formik.field.name, "yes");
                        } }, currentMutation.language.code)) }) }, currentMutation.language.code), _jsx(Caption, { fieldName: reference.id, translationKey: currentMutation.caption.translationKey })] }));
};
